"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListGripper = ListGripper;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
@adobe/react-spectrum-ui (c) by Adobe

@adobe/react-spectrum-ui is licensed under a
Creative Commons Attribution-NoDerivatives 4.0 International License.

You should have received a copy of the license along with this
work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
*/
function ListGripper({
  scale = 'M',
  ...props
}) {
  return /*#__PURE__*/_react.default.createElement("svg", props, scale === 'L' && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("circle", {
    cx: "5.375",
    cy: "12.625",
    r: "1.25"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "1.625",
    cy: "12.625",
    r: "1.25"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "5.375",
    cy: "8.875",
    r: "1.25"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "1.625",
    cy: "8.875",
    r: "1.25"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "5.375",
    cy: "5.125",
    r: "1.25"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "1.625",
    cy: "5.125",
    r: "1.25"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "5.375",
    cy: "1.375",
    r: "1.25"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "1.625",
    cy: "1.375",
    r: "1.25"
  })), scale === 'M' && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("circle", {
    cx: "4",
    cy: "10.5",
    r: "1"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "1",
    cy: "10.5",
    r: "1"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "4",
    cy: "7.5",
    r: "1"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "1",
    cy: "7.5",
    r: "1"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "4",
    cy: "4.5",
    r: "1"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "1",
    cy: "4.5",
    r: "1"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "4",
    cy: "1.5",
    r: "1"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "1",
    cy: "1.5",
    r: "1"
  })));
}

ListGripper.displayName = 'ListGripper';